import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconControllerButtonX: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconControllerButtonX"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 10.9395L8.65527 7.59473L7.59473 8.65527L10.9395 12L7.59473 15.3447L8.65527 16.4053L12 13.0605L15.3447 16.4053L16.4053 15.3447L13.0605 12L16.4053 8.65527L15.3447 7.59473L12 10.9395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconControllerButtonX;
